
  import { computed, defineComponent } from 'vue';
  import { Button, Icon, Select, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import Range from '@/components/range/Range.vue';
  import Call from '@/components/Call.vue';
  import { useStore } from 'effector-vue/composition';
  import {
    $settings,
    addActiveAudioDevice,
    addActiveVideoDevice,
    changeVolume,
    setRingtoneParam,
  } from '@/store/settings/index';
  import { changeComponent } from '@/store/components/index';
  import {
    $calls,
    $currentActiveCallId,
    $currentSelectCallId,
    changeAudioDevice,
    changeVideoDevice,
    currentSelectCall,
    openCallState,
  } from '@/store/calls';
  import appConfig from '@/config';

  interface ActiveDevice {
    label: string;
    value: string;
  }

  export default defineComponent({
    name: 'Settings',
    components: { Call, Range, Typography, Button, Icon, Select },
    setup() {
      const { t } = useI18n();
      const settings = useStore($settings);
      const activeCallId = useStore($currentActiveCallId);
      const selectCallId = useStore($currentSelectCallId);
      const allCalls = useStore($calls);
      const selectCall = useStore(currentSelectCall);
      const isCallPaused = computed(() => {
        if (!selectCall.value || selectCall.value.status === 'ENDED') return false;
        return (
          !selectCall.value?.active || allCalls.value[selectCallId.value]?.params.remotePausedState
        );
      });

      const chooseAudioDevice = (device: ActiveDevice) => {
        addActiveAudioDevice({ label: device.label, value: device.value });
        if (!settings.value.mute) changeAudioDevice(device.value);
      };
      const chooseVideoDevice = (device: ActiveDevice) => {
        addActiveVideoDevice({ label: device.label, value: device.value });
        if (!settings.value.videoMute) changeVideoDevice(device.value);
      };

      return {
        t,
        appConfig,
        settings,
        changeVolume,
        addActiveAudioDevice,
        changeComponent,
        setRingtoneParam,
        chooseAudioDevice,
        chooseVideoDevice,
        activeCallId,
        selectCallId,
        isCallPaused,
        openCallState,
      };
    },
  });
